/** @jsx jsx */
import type { PropsWithChildren } from 'react';
import { jsx } from '@compiled/react';
import AkComment from '@atlaskit/comment';

import { useCommentContext } from './CommentContextProvider.tsx';
import AkCommentAvatar from './AkCommentAvatar.tsx';
import AkCommentAfterContent from './AkCommentAfterContent.tsx';
import AKCommentCustomHeader from './AKCommentCustomHeader.tsx';
import AkCommentContent from './AkCommentContent.tsx';

const AkCommentComponent = ({ children }: PropsWithChildren) => {
	const {
		isThreadedCommentsEnabled,
		commentId,
		shouldHighlightComment,
		errorActions,
		actions,
		isError,
		isSaving,
	} = useCommentContext();

	return (
		<AkComment
			avatar={<AkCommentAvatar />}
			author={<AKCommentCustomHeader />}
			content={<AkCommentContent />}
			actions={actions}
			afterContent={<AkCommentAfterContent />}
			errorActions={errorActions}
			isError={isError}
			highlighted={shouldHighlightComment}
			testId={`issue-comment-base.ui.comment.ak-comment.${commentId}`}
			isSaving={isSaving}
			savingText=""
		>
			{isThreadedCommentsEnabled && children}
		</AkComment>
	);
};

export default AkCommentComponent;
